import { useState, useEffect } from "react";
import AdminRoutes from "../routes/AdminRoutes";
import Navbar from "../components/navigation/Navbar";
import Sidebar from "../components/navigation/Sidebar";
import { useModuleSync } from "../hooks/useModuleSync";

export default function DashboardLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [, setIsMobile] = useState(false);

  // Sync module with current route
  useModuleSync();

  // Handle responsive behavior
  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < 1024;
      setIsMobile(isMobile);
      if (!isMobile) {
        setIsSidebarOpen(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  const toggleSidebarCollapse = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <div className="flex overflow-hidden h-screen bg-gray-50">
      {/* Sidebar */}
      <Sidebar 
        isOpen={isSidebarOpen} 
        onClose={closeSidebar} 
        isCollapsed={isSidebarCollapsed}
        onToggleCollapse={toggleSidebarCollapse}
      />

      {/* Main Content Area */}
      <div className={`flex flex-col flex-1 transition-all duration-300 overflow-hidden ${
        isSidebarCollapsed ? 'lg:ml-16' : 'lg:ml-0'
      }`}>
        {/* Fixed Navbar */}
        <div className="flex-shrink-0">
          <Navbar 
            toggleSidebar={toggleSidebar} 
            isSidebarOpen={isSidebarOpen}
            isSidebarCollapsed={isSidebarCollapsed}
          />
        </div>

        {/* Main Content - Scrollable */}
        <main className="overflow-y-auto flex-1 bg-gray-50 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
          <AdminRoutes />
        </main>
      </div>
    </div>
  );
}
